export interface Category {
  slug: string;
  name: string;
  english: string;
  description: string;
  cover: string;
  keywords: string[];
}

export const categories: Category[] = [
  {
    slug: "entertainment",
    name: "娱乐观察",
    english: "Entertainment",
    description: "聚焦文娱行业的合作、解约与舆论走向，把容易情绪化的话题还原成一条条可以核对的时间线。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20collage%20artwork%20in%20warm%20cream%20and%20deep%20crimson%20tones%2C%20torn%20paper%20layers%20and%20abstract%20spotlight%20shapes%2C%20minimal%20investigative%20magazine%20mood%2C%20soft%20studio%20lighting%2C%20flat%20graphic%20style%2C%20no%20text&width=900&height=700&seq=cat-entertainment-15&orientation=landscape",
    keywords: ["娱乐事件解读", "合作解约", "舆论复盘"],
  },
  {
    slug: "business",
    name: "商业风云",
    english: "Business",
    description: "从融资、扩张到退场，拆解一家公司公开信息里最容易被忽略的几个转折点与决策逻辑。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20artwork%20with%20warm%20beige%20background%20and%20muted%20burgundy%20shapes%2C%20abstract%20chart%20lines%20and%20folder%20documents%2C%20clean%20investigative%20magazine%20aesthetic%2C%20soft%20shadow%2C%20flat%20graphic%20composition%2C%20no%20text&width=900&height=700&seq=cat-business-15&orientation=landscape",
    keywords: ["商业事件分析", "融资退场", "扩张代价"],
  },
  {
    slug: "internet",
    name: "网络热点",
    english: "Internet",
    description: "热搜会过去，但机制留在那里。我们关注话题如何被放大、被改写，以及热度退潮之后留下什么。",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20artwork%20in%20cream%20paper%20texture%20with%20warm%20amber%20and%20deep%20red%20marks%2C%20floating%20message%20bubbles%20as%20simple%20geometry%2C%20investigative%20collage%20mood%2C%20soft%20light%2C%20no%20text&width=900&height=700&seq=cat-internet-15&orientation=landscape",
    keywords: ["热搜复盘", "舆情机制", "话题传播"],
  },
  {
    slug: "society",
    name: "社会话题",
    english: "Society",
    description: "把公共议题中绕不开的疑问摆出来：谁的诉求被听见了，哪个环节存在明显的信息断层。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20abstract%20artwork%20with%20warm%20sand%20and%20stone%20colours%2C%20layered%20paper%20texture%20and%20thin%20crimson%20lines%2C%20neutral%20documentary%20magazine%20mood%2C%20soft%20daylight%2C%20flat%20graphic%20style%2C%20no%20text&width=900&height=700&seq=cat-society-15&orientation=landscape",
    keywords: ["公共议题", "信息断层", "民生复盘"],
  },
  {
    slug: "tech",
    name: "科技前沿",
    english: "Technology",
    description: "技术本身很少背锅，真正值得追问的是它被谁使用、规则有没有跟上、代价落在了谁身上。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20artwork%20in%20warm%20paper%20tones%20with%20abstract%20geometric%20circuit%20shapes%20and%20amber%20highlights%2C%20technical%20yet%20cosy%20investigative%20aesthetic%2C%20soft%20studio%20lighting%2C%20flat%20composition%2C%20no%20text&width=900&height=700&seq=cat-tech-15&orientation=landscape",
    keywords: ["技术争议", "隐私边界", "开源社区"],
  },
];